import { graphql } from "react-relay";

export const UpdateSSOAPIKeysMutation = graphql`
  mutation UpdateSSOAPIKeysMutation($input: UpdateSSOAPIKeysInput!) {
    updateSSOAPIKeys(input: $input) {
      problems {
        message
      }
      ssoAPIKeys
    }
  }
`;
